import SidebarLayout from "@/common/components/SidebarLayout";
import { useSlugParam } from "@/common/hooks/useParam";
import { useSidebar } from "@/common/hooks/useSidebar";

import FeatureSidebar from "../components/FeatureSidebar";

type FeatureSideBarWrapperProps = {
  children: React.ReactNode;
};

export default function FeatureSideBarWrapper({
  children,
}: FeatureSideBarWrapperProps) {
  const { featureId } = useSlugParam("feature");
  const { isVisible } = useSidebar(featureId);

  return isVisible ? (
    <SidebarLayout
      flexGrow={1}
      sidebarContent={<FeatureSidebar featureId={featureId} />}
      sidebarKey={featureId}
    >
      {children}
    </SidebarLayout>
  ) : (
    children
  );
}
